<ng-container *ngIf="(currency$ | async) as currency">
  <ng-container *ngIf="transform(currency) as result">
    <span class="currency-prefix">{{ currency.prefix }}&nbsp;</span>
    <span class="currency-main">{{ result.sum }}</span>
    <span class="currency-rest" *ngIf="result.rest">
      <span class="currency-main">.</span>{{ result.rest }}
    </span>
  </ng-container>
</ng-container>
